import React, { memo } from 'react';
import { onClickHandler } from '../../../utils/onclick';

import './index.scss';

type ACheckBoxProps = {
    label: string;
    set: () => void;
    value: boolean;
    disabled?: boolean;
};

export const SettingCheckBoxComponent = memo(function SettingCheckBoxComponent({ label, set, value, disabled }: ACheckBoxProps) {
    const classNames = ['checkmark'];
    if (disabled) classNames.push('disabled');
    if (value) classNames.push('checked');
    return (
        <div className='line'>
            <div className='left'>
                <span>{label}</span>
            </div>
            <div className='right'>
                <div {...onClickHandler(set, disabled)} className={classNames.join(' ')} />
            </div>
        </div>
    );
});